import { Container, ContainerProps } from "@mantine/core"

export type ContentContainerProps = ContainerProps & {

}

export const ContentContainer = (props: ContentContainerProps) => {
  return <Container size='xl' {...props} />
}